import React, { useCallback } from 'react';
import logo from "../../assets/images/csd-logo.svg";
import { useMsal } from '@azure/msal-react';
import { Trans, useTranslation } from "react-i18next";
import Button from '@material-ui/core/Button';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { getAzureAdScopes } from '../../services/authService';
import css from "./Login.module.scss";
import usePersistedAppQueryParams from '../../shared/usePersistedAppQueryParams';
import i18next from 'i18next';

const Login: React.FC = () => {

    const { instance } = useMsal();
    const { lang } = usePersistedAppQueryParams();

    const doLogin = useCallback(() => {
        instance.loginRedirect({ scopes: getAzureAdScopes()});
    }, [instance]);

    React.useEffect(() => {
        i18next.changeLanguage(lang);
    }, [lang]);

    const { t } = useTranslation();

    return (
        <div className={css.login} >
            <div className={css.csdFlow}>
                <div className="centered" style={{ flex: 1, flexDirection: 'column' }}>
                    <div><img src={logo} alt="Carestream Dental Logo" style={{ width: 370 }} /></div>

                    <h3 className="csd-purple" style={{ paddingTop: 50 }}>
                        {t("Device registration")}
                    </h3>

                    <section style={{ paddingTop: 40, textAlign: 'center' }}>
                        <Trans>In order to use this application, you must login using your <strong>Carestream Dental</strong> account.</Trans>
                    </section>

                    <div style={{ paddingTop: 40 }}>
                        <Button className={css.loginButton} startIcon={<ExitToAppIcon />} style={{ minWidth: 120 }} onClick={doLogin}>{t('LOGIN')}</Button>
                    </div>
                </div>
            </div >
        </div>
    );
}

export default Login;


